import * as actionTypes from './actionTypes'
import { UPLOAD_PHOTO_WIZARD_STATE } from "./constants";

const initialState = {
  uploadNewPhotosWizardState: UPLOAD_PHOTO_WIZARD_STATE.CATEGORY_SELECTION,
  busCategoriesList: [],
  busServicesForCategories: {},
  selectedBusCategory: null,
  isSelectedService: false,
  isSelectAllServices: false,
  selectedBusServices: {},
  uploadSelectedPhotos: [],
  userInfo: {},
  metaDetails: {},
  successData: {},
}

export default (state = initialState, { type, payload }) => {
    switch (type) {
      case actionTypes.META_DETAILS: {
        return {
          ...state,
          metaDetails: {
            amenities: payload.data.amenities,
            ...payload.data.photos,
          }
        }
      }
      case actionTypes.CATEGORY_LIST: {
        return {
          ...state,
          uploadNewPhotosWizardState: UPLOAD_PHOTO_WIZARD_STATE.CATEGORY_SELECTION,
          busCategoriesList: payload.data
        }
      }
      case actionTypes.GO_TO_CATEGORY_SELECTION: {
        return {
          ...state,
          uploadNewPhotosWizardState: UPLOAD_PHOTO_WIZARD_STATE.CATEGORY_SELECTION,
        }
      }
      case actionTypes.SERVICES_LIST:
        // reset the selected services and selected all bool, whenever cat change
        return {
          ...state,
          uploadNewPhotosWizardState: UPLOAD_PHOTO_WIZARD_STATE.ROUTES_SELECTION,
          busServicesForCategories: {
            ...state.busServicesForCategories,
            [payload.busCategory]: payload.servicesForCategory
          },
          selectedBusServices: {},
          isSelectAllServices: false,
          selectedBusCategory: payload.busCategory,
          userInfo: payload.userInfo
        }
      case actionTypes.GO_TO_SERVICES_SELECTION: {
        return {
          ...state,
          uploadNewPhotosWizardState: UPLOAD_PHOTO_WIZARD_STATE.ROUTES_SELECTION,
        }
      }
      case actionTypes.SELECT_INDIVIDUAL_SERVICES_HANDLER: {
        let selectedBusServices = { ...state.selectedBusServices };
        if(!payload.isSelectedService) {
          delete selectedBusServices[payload.selectedRoute];
        } else {
          selectedBusServices[payload.selectedRoute] = true;
        }
        return {
          ...state,
          isSelectAllServices: false,
          isSelectedService: payload.isSelectedService,
          selectedBusServices
        }
      }
      case actionTypes.SELECT_ALL_SERVICES_HANDLER: {
        let selectedBusServices = {};
        if(payload.isSelectAllServices) {
          state.busServicesForCategories[state.selectedBusCategory].forEach(busService => {
            selectedBusServices[busService.route_time_id] = true;
          });
        } else {
          selectedBusServices = {}
        }
        return {
          ...state,
          isSelectAllServices: payload.isSelectAllServices,
          selectedBusServices
        }
      }
      case actionTypes.GO_TO_PHOTOS_SELECTION:
        return {
          ...state,
          uploadNewPhotosWizardState: UPLOAD_PHOTO_WIZARD_STATE.PHOTOS_SELECTION
        }
      case actionTypes.SET_PHOTOS_TO_UPLOAD:
        return{
          ...state,
          uploadSelectedPhotos: [...payload.uploadSelectedPhotos]
        }
      case actionTypes.UPLOAD_SELECTED_PHOTOS_HANDLER:
        return {
          ...state,
          successData: payload
        }
      case actionTypes.RESET_STORE:
        return {
          ...state,
          uploadNewPhotosWizardState: UPLOAD_PHOTO_WIZARD_STATE.CATEGORY_SELECTION,
          busServicesForCategories: {},
          selectedBusCategory: null,
          isSelectedService: false,
          isSelectAllServices: false,
          selectedBusServices: {},
          uploadSelectedPhotos: [],
          userInfo: {},
          successData: {},
        }
      default:
        return state
    }
  }